export const ONLY_NUMBER = /[^0-9., ]+/g; // eslint-disable-line import/prefer-default-export
